'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _event = require('linksoft/core/event');

var _event2 = _interopRequireDefault(_event);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common');

_event2.default.on('linksoft.datatables.savingFailed', function (e, f, g) {
	e.notify = false;

	if (parseInt(e.cell.previousSibling.innerText) < e.data.soldAmount) {
		_notify2.default.error(Resx.App.ComissionSetSoldAmountValidation);
	} else if (e.data.soldAmount < 0) {
		_notify2.default.error(Resx.App.ComissionSetSoldNegativeValidation);
	} else {
		_notify2.default.error(Resx.Common.AjaxError);
	}
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/comissionStockDt.js
// module id = 912
// module chunks = 0